
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talents/[slug]",
      function () {
        return require("private-next-pages/talents/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talents/[slug]"])
      });
    }
  